const fetchAs = require("./fetchAs");

module.exports = async function fetchListContentFilters(list_data, dispatch) {
	const { field_entities_list_by_content } = list_data;
	if (!field_entities_list_by_content) return null;
	let _filteringByContent = {};
	for (const a_content_rel of field_entities_list_by_content) {
		let bundle = a_content_rel.type.split("--")[1];
		let _rel_entity = await fetchAs({
			endpoint: `node/${bundle}/${a_content_rel.id}`,
			dispatch,
			testing: true,
		});
		if (_rel_entity && _rel_entity.data) {
			_filteringByContent[a_content_rel.id] = _rel_entity.data;
		}
	}
	return _filteringByContent;
};
